<template>
  <div class="container">
    <el-container style="height: 100%;">
      <el-header>
        <nav-bar></nav-bar>
      </el-header>
      <el-container class="content">
          <el-aside  width="220px">
            <menu-tree></menu-tree>
          </el-aside>
          <el-container style="height: 100%;">
            <el-main >
              <app-main ref="appMain"></app-main>
            </el-main>
            <el-footer >
              <app-footer></app-footer>
            </el-footer>
          </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import NavBar from '@/components/layout/nav-bar.vue'
import MenuTree from '@/components/layout/menu-tree.vue'
import AppMain from '@/components/layout/app-main.vue'
import AppFooter from '@/components/layout/app-footer.vue'

export default {
    name: 'Home',
    components: {NavBar,MenuTree,AppMain,AppFooter},
    methods:{

    },
    created() {
    },
}
</script>


<style lang="scss" scoped>
.container{
  // width: 100%;
  height: 100%;
  height: auto !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // background: url('../../assets/image/home/home_back.jpg') no-repeat;

  // -moz-background-size: 100% 100%;
  // background-size: 100% 100%;
  padding: 0;
  margin: 0;

  .el-header {
    width: 100%;
    padding: 0;
    // background: RGBA(20, 54, 115, 1);
    height: $header-height !important;
    overflow: hidden;
    position: fixed;
    z-index:999;
    background-color: $sidebar-background;
  }





  .content{
    width: 100%;
    height: 100%;

    .el-aside{
      background-color: $sidebar-background;
      height:  auto !important;
      height: 100%;
      width:$sidebar-width;
      border: none;
      padding: 0;
      margin: 0;
      margin-top: $header-height;
      position: fixed;
      top: 0;
      bottom: 0;
      border-right: 1px rgba(45,65,91,0.35) solid;
    }

    .el-main{
      // width: 100%;
      // height: 99%;
      height: 80%;
      margin-left: $sidebar-width;
      // background-color: $sidebar-background;
      // background-color: greenyellow;

      background-color: $sidebar-background;
    }

    .el-footer {
      margin-left: $sidebar-width;
      // // width: 100%;
      // padding: 0;
      // // background: RGBA(20, 54, 115, 1);
      // // height: $header-height !important;
      // overflow: hidden;
      // position: fixed;
      // z-index:999;
      background-color: $sidebar-background;
      // height: $header-height;
      // background-color: cadetblue;
      // margin-top: 30px;
      // height: 600px;
      // background-color: cadetblue;
      text-align: center;
      position: relative;
      bottom: 0;
      // z-index: 998;
      // width: 100%;
      // background-color: yellow;
    }



  }
}

</style>



// WEBPACK FOOTER //
// src/view/home/home.vue